import { z } from 'zod';

export const isoUtcDateTimeSchema = z.string().datetime({ offset: true });
export type IsoUtcDateTime = z.infer<typeof isoUtcDateTimeSchema>;

export const positiveIntIdSchema = z.coerce.number().int().positive();